import {Injectable} from '@angular/core';
import {DocumentModel} from '../models/document.model';
import {AlertController} from '@ionic/angular';
import {LokijsService} from './database/lokijs.service';
import {PatientDTOModel} from '../models/patientDTO.model';
import {DocumentTypes} from '../definitions/document-types';
import {StateManagerService} from './state-manager.service';
import {CollectionsNames} from '../definitions/collections-names';
import {MobileConfigurationModel} from '../models/mobile-configuration.model';

@Injectable({
    providedIn: 'root'
})
export class ValidateDocumentService {

    constructor(private alertController: AlertController,
                private lokiJs: LokijsService,
                private docTypes: DocumentTypes,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames) {
    }

    isValid(doc: DocumentModel) {
        const mobileConfiguration: MobileConfigurationModel = this.stateManagerService.getCollection(this.collectionsNames.MOBILECONFIGURATION);
        if (mobileConfiguration && mobileConfiguration.mobilehireHealthCareInUse === 1) {
            this.checkPatient(doc);
        }
        this.checkChangeOver(doc);
        if (!doc.detailLines || doc.detailLines.length <= 0) {
            console.log('Invalid doc');
            this.missingItems('No Items added', 'You need to select Items to proceed!');
            return false;
        }

        if (doc.documentType === 1 && !this.checkDetailLine(doc)) {
            console.log('Invalid detail lines');
            return false;
        }

        return true;
    }

    async missingItems(header, msg) {
        const alert = await this.alertController.create({
            header: header,
            message: msg,
            backdropDismiss: false,
            buttons: [
                {
                    text: 'Ok',
                    role: 'cancel'
                }
            ]
        });
        await alert.present();
    }

    checkDetailLine(doc: DocumentModel) {
        const ptSerials = this.lokiJs.getCollection('ptserial').chain().data();
        for (const line of doc.detailLines) {
            if (line.custId && doc.customer.id && line.custId !== doc.customer.id) {
                this.missingItems('Detail Lines for different Customers',
                    'There are detail lines for different customers, please remove these lines to proceed.');
                return false;
            }
            if (line.pdesc) {
                if (line.typ === 'S' && !line.reg) {
                    this.missingItems('Invalid Line', 'The Item '
                    + line.overrideDescriptionNote ? line.overrideDescriptionNote : line.description
                        + ' is a single item but has no reg number associated');
                    return false;
                }
            } else if (line.plu) {
                if (ptSerials && ptSerials.length > 0) {
                    const tempPtSerialsList = this.lokiJs.getCollection('ptserial').chain().find({productTypeId: line.id}).data();
                    if (tempPtSerialsList && tempPtSerialsList.length > 0 && line.ptSerialBeans.length <= 0) {
                        this.missingItems('Invalid Line', 'The Item '
                        + line.comment ? line.comment : line.description
                            + ' has a serial associated and no serial was selected.');
                        return false;
                    }
                }
            } else {
                this.missingItems('Invalid Line', 'The Item '
                + line.description ? line.description : 'UNKNOWN'
                    + ' is not a valid Item');
                return false;
            }
        }
        return true;
    }

    private checkPatient(doc: DocumentModel) {
        if (!doc.patient || (!doc.patient.id && !doc.patient.firstName && !doc.patient.lastName)) {
            doc.patient = new PatientDTOModel();
            doc.patient.id = 'Unknown Patient';
            doc.patient.firstName = 'Unknown Patient';
            doc.patient.lastName = 'Unknown Patient';
        }
    }

    private checkChangeOver(doc: DocumentModel) {
        // if (this.)
    }
}
